import React from 'react';
import Styles from './styles.module.css';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

// スライドの切り替え ‹  ━ • •  › と「1 / 4店舗」。学生アプリの RecruitPager(recruit_section.dart)と同じ見た目。
type RecruitPagerProps = {
  index: number;
  total: number;
  unit?: string; // 「店舗」「人」など
  onPrev: () => void;
  onNext: () => void;
};

const RecruitPager: React.FC<RecruitPagerProps> = ({ index, total, unit = "", onPrev, onNext }) => (
  <div className={Styles.pager}>
    <button type="button" aria-label="前へ" className={Styles.arrow} disabled={index <= 0} onClick={onPrev}>
      <IoChevronBack />
    </button>
    <div className={Styles.center}>
      <div className={Styles.dots}>
        {Array.from({ length: Math.min(total, 10) }, (_, i) => (
          <span key={i} className={i === index ? `${Styles.dot} ${Styles.dot_active}` : Styles.dot} />
        ))}
      </div>
      <p className={Styles.count}>{index + 1} / {total}{unit}</p>
    </div>
    <button type="button" aria-label="次へ" className={Styles.arrow} disabled={index >= total - 1} onClick={onNext}>
      <IoChevronForward />
    </button>
  </div>
);

export default RecruitPager;
